export const blockIconsActivitiesSwordsNew = (
	<span className='material-symbols-outlined'>swords</span>
);
